/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type GetAuthClientAudienceSecurity = {
  sessionHeaderGramSession?: string | undefined;
  apikeyHeaderGramKey?: string | undefined;
};

export type GetAuthClientAudienceRequest = {
  /**
   * The auth client id.
   */
  id: string;
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
};

/** @internal */
export type GetAuthClientAudienceSecurity$Outbound = {
  "session_header_Gram-Session"?: string | undefined;
  "apikey_header_Gram-Key"?: string | undefined;
};

/** @internal */
export const GetAuthClientAudienceSecurity$outboundSchema: z.ZodMiniType<
  GetAuthClientAudienceSecurity$Outbound,
  GetAuthClientAudienceSecurity
> = z.pipe(
  z.object({
    sessionHeaderGramSession: z.optional(z.string()),
    apikeyHeaderGramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      sessionHeaderGramSession: "session_header_Gram-Session",
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
    });
  }),
);

export function getAuthClientAudienceSecurityToJSON(
  getAuthClientAudienceSecurity: GetAuthClientAudienceSecurity,
): string {
  return JSON.stringify(
    GetAuthClientAudienceSecurity$outboundSchema.parse(
      getAuthClientAudienceSecurity,
    ),
  );
}

/** @internal */
export type GetAuthClientAudienceRequest$Outbound = {
  id: string;
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
};

/** @internal */
export const GetAuthClientAudienceRequest$outboundSchema: z.ZodMiniType<
  GetAuthClientAudienceRequest$Outbound,
  GetAuthClientAudienceRequest
> = z.pipe(
  z.object({
    id: z.string(),
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
    });
  }),
);

export function getAuthClientAudienceRequestToJSON(
  getAuthClientAudienceRequest: GetAuthClientAudienceRequest,
): string {
  return JSON.stringify(
    GetAuthClientAudienceRequest$outboundSchema.parse(
      getAuthClientAudienceRequest,
    ),
  );
}
